export enum PortalQsmType {
  Multidestination = 0,
  Accommodation = 1,
  AccommodationAndFlight = 2,
  Flight = 3,
  RoundTrip = 4,
  GroupTour = 5,
  Package = 6,
  Ticket = 7,
  Car = 8,
  Transfer = 9,
  Cruise = 10,
}
